import { apiClient } from "../../lib/apiClient";
import type { FleetOutageSnapshotResponse } from "../types";

export const FleetOutageService = {
  /**
   * Fetches current outage state for every facility in one call — the
   * initial snapshot paired with useFleetOutageStream's admin SSE
   * connection (FE push architecture spec §2.3, FE-6). Platform-admin
   * only; no frontend auth handling needed beyond the existing role gate
   * on the caller.
   */
  async fetchFleetOutages() {
    return await apiClient.get<FleetOutageSnapshotResponse>(
      "/api/v1/admin/telemetry-outages",
    );
  },
};
